import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import SuccessScreen from 'creative-ui/oktaComponents/SuccessScreen';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import verificationMailSvg from '@/assets/verification-mail.svg';
import { BackToLogin } from '@/components/Buttons/BackToLogin';
import Text from '@/components/Typography/Text/Text';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { trackPageView } from '@/lib/tagging';
import { ResendEmail } from '@/screens/reset-password-email/components/ResendEmail';

import { useResetPasswordEmailManager } from './hooks/useResetPasswordEmailManager';

// Main Reset Password Email Screen
function ResetPasswordEmailScreen() {
  const { t } = useTranslation('resetPasswordEmail');
  useTransactionLocale();
  const { data } = useResetPasswordEmailManager();

  useEffect(() => {
    trackPageView('recovery/email/sent');
  }, []);

  // biome-ignore lint/suspicious/noExplicitAny: <The auth0-acul-react (1.0.0) sdk defines only username in data but the coming data from the auth0 tenant has email field>
  const email = data?.username || (data as any)?.email || '';

  const title = t('resetPasswordForm.title');
  const description = t('resetPasswordForm.description', { email });

  document.title = t('pageTitle');

  const handleBack = () => {
    window.history.back();
  };

  return (
    <BaseWrapper backCtaProps={{ onClick: handleBack }}>
      <SuccessScreen
        title={title}
        text={description}
        image={verificationMailSvg}
        isTextBeforeImage={false}>
        <Text align="center" bold className="u-margin-b-m">
          {email}
        </Text>
        <Text align="center" accent="inactive" className="u-margin-b-m">
          {t('resetPasswordForm.noEmailReceived')}
        </Text>
        <ResendEmail />
        <BackToLogin variant="tertiary" />
      </SuccessScreen>
    </BaseWrapper>
  );
}

export default ResetPasswordEmailScreen;
